// import { useEffect, useState, useCallback, useMemo } from "react";
// import { useSearchParams } from "react-router-dom";
// import "./UploadedImages.css";

// // const API_BASE = "https://testapi4.kaalo.com";
// const API_BASE = "https://api.arlearning.in";
// // const API_BASE = "http://localhost:8000";

// export default function UploadedImages({ apiPrefix = "" }) {
//   const [folders, setFolders] = useState([]);
//   const [rootFiles, setRootFiles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deleting, setDeleting] = useState(false);

//   const [searchParams, setSearchParams] = useSearchParams();
//   const currentFolder = searchParams.get("folder");
//   const currentBatch = searchParams.get("batch");

//   const isServerUploads = apiPrefix === "";

//   const processFile = useCallback(
//     (f, index = 0) => {
//       const filename = f.filename;
//       const fullUrl = f.url || API_BASE + f.viewUrl;
//       const fileKey = f.key || filename;

//       let thumbUrl;

//       if (isServerUploads) {
//         thumbUrl = fullUrl;
//       } else {
//         thumbUrl = `${API_BASE}/app/thumbnail/?key=${encodeURIComponent(fileKey)}`;
//       }

//       return {
//         key: fileKey || `dev-${index}`,
//         filename: filename,
//         url: fullUrl,
//         thumbnail: thumbUrl,
//         originalKey: fileKey,
//       };
//     },
//     [isServerUploads],
//   );

//   const fetchRoot = useCallback(async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${API_BASE}${apiPrefix}/uploads-list`);
//       if (!res.ok) throw new Error("Failed to fetch");

//       const data = await res.json();

//       if (Array.isArray(data)) {
//         setFolders([]);
//         setRootFiles(data.map(processFile));
//         setSearchParams({});
//         return;
//       }

//       const processedFolders = (data.folders || []).map((folder) => ({
//         ...folder,
//         files: (folder.files || []).map(processFile),
//       }));

//       setFolders(processedFolders);
//       setRootFiles((data.files || []).map(processFile));
//     } catch (e) {
//       setError(e.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [apiPrefix, setSearchParams, processFile]);

//   useEffect(() => {
//     fetchRoot();
//   }, [fetchRoot]);

//   const deleteFile = async (file) => {
//     try {
//       setDeleting(true);
//       let url;

//       if (isServerUploads) {
//         url = `${API_BASE}/delete/${encodeURIComponent(file.filename)}`;
//       } else {
//         url = `${API_BASE}${apiPrefix}/delete?key=${encodeURIComponent(file.originalKey || file.key)}`;
//       }

//       const res = await fetch(url, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed");

//       setRootFiles((prev) => prev.filter((f) => f.key !== file.key));

//       setFolders((prev) =>
//         prev
//           .map((folder) => ({
//             ...folder,
//             files: folder.files.filter((f) => f.key !== file.key),
//           }))
//           .filter((folder) => folder.files.length > 0),
//       );
//     } catch (err) {
//       alert("Error deleting: " + err.message);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const deleteBatch = async (batchName) => {
//     try {
//       setDeleting(true);
//       const prefix = `${currentFolder}/${batchName}/`;

//       const res = await fetch(
//         `${API_BASE}${apiPrefix}/delete-batch?prefix=${encodeURIComponent(prefix)}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed");

//       setFolders((prevFolders) => {
//         return prevFolders
//           .map((folder) => {
//             if (folder.name !== currentFolder) return folder;
//             const newFiles = folder.files.filter(
//               (f) => !f.key.includes(`/${batchName}/`),
//             );
//             return { ...folder, files: newFiles };
//           })
//           .filter((folder) => folder.files.length > 0);
//       });

//       setSearchParams({ folder: currentFolder });
//     } catch (err) {
//       alert("Error deleting batch: " + err.message);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const currentFolderObj = useMemo(
//     () => folders.find((f) => f.name === currentFolder),
//     [folders, currentFolder],
//   );

//   const batches = useMemo(() => {
//     if (!currentFolderObj) return {};

//     const map = {};
//     currentFolderObj.files.forEach((file) => {
//       const parts = file.key.split("/");
//       if (parts.length >= 2) {
//         const batchName = parts[parts.length - 2];
//         if (!map[batchName]) map[batchName] = [];
//         map[batchName].push(file);
//       }
//     });

//     return Object.fromEntries(
//       Object.entries(map).sort((a, b) => b[0].localeCompare(a[0])),
//     );
//   }, [currentFolderObj]);

//   if (loading)
//     return (
//       <div className="loader-container">
//         <div className="loader"></div>
//       </div>
//     );
//   if (error) return <div className="status error">{error}</div>;

//   return (
//     <div className="gallery-page">
//       {(currentFolder || currentBatch) && (
//         <div className="breadcrumb">
//           <span onClick={() => setSearchParams({})}>Home</span>
//           {currentFolder && (
//             <>
//               <span className="separator">/</span>
//               <span onClick={() => setSearchParams({ folder: currentFolder })}>
//                 {currentFolder}
//               </span>
//             </>
//           )}
//           {currentBatch && (
//             <>
//               <span className="separator">/</span>
//               <span>{currentBatch}</span>
//             </>
//           )}
//         </div>
//       )}

//       <div className="gallery">
//         {!currentFolder &&
//           folders.map((folder) => (
//             <div
//               key={folder.name}
//               className="folder-card"
//               onClick={() => setSearchParams({ folder: folder.name })}
//             >
//               <div className="folder-icon">
//                 <img src="/assets/folder.png" alt="Folder" />
//               </div>
//               <div className="folder-name">{folder.name}</div>
//               <div className="folder-count">{folder.files.length} items</div>
//             </div>
//           ))}

//         {!currentFolder &&
//           rootFiles.map((file) => (
//             <FileCard
//               key={file.key}
//               file={file}
//               isServerUploads={isServerUploads}
//               deleting={deleting}
//               onDelete={() => deleteFile(file)}
//             />
//           ))}

//         {currentFolder &&
//           !currentBatch &&
//           Object.keys(batches).map((batchName) => (
//             <div key={batchName} className="folder-card batch-card">
//               <button
//                 className="action-circle-btn delete-btn"
//                 disabled={deleting}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   if (window.confirm(`Delete batch "${batchName}"?`))
//                     deleteBatch(batchName);
//                 }}
//               >
//                 <img src="/assets/delete.png" alt="Delete" />
//               </button>
//               <div
//                 className="batch-content"
//                 onClick={() =>
//                   setSearchParams({ folder: currentFolder, batch: batchName })
//                 }
//               >
//                 <div className="folder-icon">
//                   <img src="/assets/folder.png" alt="Batch" />
//                 </div>
//                 <div className="folder-name">{batchName}</div>
//                 <div className="folder-count">
//                   {batches[batchName].length} items
//                 </div>
//               </div>
//             </div>
//           ))}

//         {currentFolder &&
//           currentBatch &&
//           batches[currentBatch]?.map((file) => (
//             <FileCard
//               key={file.key}
//               file={file}
//               isServerUploads={isServerUploads}
//               deleting={deleting}
//               onDelete={() => deleteFile(file)}
//             />
//           ))}

//         {currentFolder &&
//           currentBatch &&
//           (!batches[currentBatch] || batches[currentBatch].length === 0) && (
//             <div className="empty-msg">This folder is empty.</div>
//           )}
//       </div>

//       {deleting && (
//         <div className="delete-overlay">
//           <div className="loader"></div>
//         </div>
//       )}
//     </div>
//   );
// }

// function FileCard({ file, onDelete, deleting, isServerUploads }) {
//   const [imageLoaded, setImageLoaded] = useState(false);

//   const downloadHref = isServerUploads
//     ? `${API_BASE}/download/${encodeURIComponent(file.filename)}`
//     : file.url;

//   return (
//     <div className="file-card">
//       <div className="file-image-wrapper">
//         {!imageLoaded && <div className="skeleton-loader"></div>}

//         <img
//           src={file.thumbnail}
//           alt={file.filename}
//           loading="lazy"
//           decoding="async"
//           className={imageLoaded ? "img-loaded" : "img-loading"}
//           onLoad={() => setImageLoaded(true)}
//           onError={(e) => {
//             if (e.target.src !== file.url) {
//               e.target.src = file.url;
//             } else {
//               e.target.style.display = "none";
//             }
//           }}
//         />

//         {onDelete && (
//           <button
//             className="action-circle-btn file-delete-btn"
//             disabled={deleting}
//             onClick={(e) => {
//               e.stopPropagation();
//               if (window.confirm("Delete this file?")) onDelete();
//             }}
//           >
//             <img src="/assets/delete.png" alt="Delete" />
//           </button>
//         )}
//       </div>

//       <div className="file-meta">
//         <span className="file-name" title={file.filename}>
//           {file.filename}
//         </span>

//         <a
//           href={downloadHref}
//           download
//           className="action-circle-btn download-btn"
//         >
//           <img src="/assets/download.png" alt="Download" />
//         </a>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import "./UploadedImages.css";

// const API_BASE = "https://testapi4.kaalo.com";
const API_BASE = "https://api.arlearning.in";
// const API_BASE = "http://localhost:8000";

export default function UploadedImages({ apiPrefix = "", source = "app" }) {
  const [folders, setFolders] = useState([]);
  const [rootFiles, setRootFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deleting, setDeleting] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const currentFolder = searchParams.get("folder");
  const currentBatch = searchParams.get("batch");

  const isServerUploads = apiPrefix === "";

  const processFile = useCallback(
    (f, index = 0) => {
      const filename = f.filename;
      const fullUrl = f.url || API_BASE + f.viewUrl;
      const fileKey = f.key || filename;

      let thumbUrl;

      if (isServerUploads) {
        thumbUrl = fullUrl;
      } else {
        thumbUrl = `${API_BASE}/app/thumbnail/?key=${encodeURIComponent(fileKey)}`;
      }

      return {
        key: fileKey || `dev-${index}`,
        filename: filename,
        url: fullUrl,
        thumbnail: thumbUrl,
        originalKey: fileKey,
      };
    },
    [isServerUploads],
  );

  const fetchRoot = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${API_BASE}${apiPrefix}/uploads-list?source=${source}`,
      );
      if (!res.ok) throw new Error("Failed to fetch");

      const data = await res.json();

      if (Array.isArray(data)) {
        setFolders([]);
        setRootFiles(data.map(processFile));
        setSearchParams({});
        return;
      }

      const processedFolders = (data.folders || []).map((folder) => ({
        ...folder,
        files: (folder.files || []).map(processFile),
      }));

      setFolders(processedFolders);
      setRootFiles((data.files || []).map(processFile));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [apiPrefix, setSearchParams, processFile, source]);

  useEffect(() => {
    fetchRoot();
  }, [fetchRoot]);

  const deleteFile = async (file) => {
    try {
      setDeleting(true);
      let url;

      if (isServerUploads) {
        url = `${API_BASE}/delete/${encodeURIComponent(file.filename)}`;
      } else {
        url = `${API_BASE}${apiPrefix}/delete?key=${encodeURIComponent(file.originalKey || file.key)}`;
      }

      const res = await fetch(url, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed");

      setRootFiles((prev) => prev.filter((f) => f.key !== file.key));

      setFolders((prev) =>
        prev
          .map((folder) => ({
            ...folder,
            files: folder.files.filter((f) => f.key !== file.key),
          }))
          .filter((folder) => folder.files.length > 0),
      );
    } catch (err) {
      alert("Error deleting: " + err.message);
    } finally {
      setDeleting(false);
    }
  };

  const deleteBatch = async (batchName) => {
    try {
      setDeleting(true);
      const prefix = `${currentFolder}/${batchName}/`;

      const res = await fetch(
        `${API_BASE}${apiPrefix}/delete-batch?prefix=${encodeURIComponent(prefix)}&source=${source}`,
        { method: "DELETE" },
      );
      if (!res.ok) throw new Error("Failed");

      setFolders((prevFolders) => {
        return prevFolders
          .map((folder) => {
            if (folder.name !== currentFolder) return folder;
            const newFiles = folder.files.filter(
              (f) => !f.key.includes(`/${batchName}/`),
            );
            return { ...folder, files: newFiles };
          })
          .filter((folder) => folder.files.length > 0);
      });

      setSearchParams({ folder: currentFolder });
    } catch (err) {
      alert("Error deleting batch: " + err.message);
    } finally {
      setDeleting(false);
    }
  };

  const currentFolderObj = useMemo(
    () => folders.find((f) => f.name === currentFolder),
    [folders, currentFolder],
  );

  const batches = useMemo(() => {
    if (!currentFolderObj) return {};

    const map = {};
    currentFolderObj.files.forEach((file) => {
      const parts = file.key.split("/");
      if (parts.length >= 2) {
        const batchName = parts[parts.length - 2];
        if (!map[batchName]) map[batchName] = [];
        map[batchName].push(file);
      }
    });

    return Object.fromEntries(
      Object.entries(map).sort((a, b) => b[0].localeCompare(a[0])),
    );
  }, [currentFolderObj]);

  if (loading)
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  if (error) return <div className="status error">{error}</div>;

  return (
    <div className="gallery-page">
      {(currentFolder || currentBatch) && (
        <div className="breadcrumb">
          <span onClick={() => setSearchParams({})}>Home</span>
          {currentFolder && (
            <>
              <span className="separator">/</span>
              <span onClick={() => setSearchParams({ folder: currentFolder })}>
                {currentFolder}
              </span>
            </>
          )}
          {currentBatch && (
            <>
              <span className="separator">/</span>
              <span>{currentBatch}</span>
            </>
          )}
        </div>
      )}

      <div className="gallery">
        {!currentFolder &&
          folders.map((folder) => (
            <div
              key={folder.name}
              className="folder-card"
              onClick={() => setSearchParams({ folder: folder.name })}
            >
              <div className="folder-icon">
                <img src="/assets/folder.png" alt="Folder" />
              </div>
              <div className="folder-name">{folder.name}</div>
              <div className="folder-count">{folder.files.length} items</div>
            </div>
          ))}

        {!currentFolder &&
          rootFiles.map((file) => (
            <FileCard
              key={file.key}
              file={file}
              isServerUploads={isServerUploads}
              deleting={deleting}
              onDelete={() => deleteFile(file)}
            />
          ))}

        {currentFolder &&
          !currentBatch &&
          Object.keys(batches).map((batchName) => (
            <div key={batchName} className="folder-card batch-card">
              <button
                className="action-circle-btn delete-btn"
                disabled={deleting}
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`Delete batch "${batchName}"?`))
                    deleteBatch(batchName);
                }}
              >
                <img src="/assets/delete.png" alt="Delete" />
              </button>
              <div
                className="batch-content"
                onClick={() =>
                  setSearchParams({ folder: currentFolder, batch: batchName })
                }
              >
                <div className="folder-icon">
                  <img src="/assets/folder.png" alt="Batch" />
                </div>
                <div className="folder-name">{batchName}</div>
                <div className="folder-count">
                  {batches[batchName].length} items
                </div>
              </div>
            </div>
          ))}

        {currentFolder &&
          currentBatch &&
          batches[currentBatch]?.map((file) => (
            <FileCard
              key={file.key}
              file={file}
              isServerUploads={isServerUploads}
              deleting={deleting}
              onDelete={() => deleteFile(file)}
            />
          ))}

        {currentFolder &&
          currentBatch &&
          (!batches[currentBatch] || batches[currentBatch].length === 0) && (
            <div className="empty-msg">This folder is empty.</div>
          )}
      </div>

      {deleting && (
        <div className="delete-overlay">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
}

function FileCard({ file, onDelete, deleting, isServerUploads }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const downloadHref = isServerUploads
    ? `${API_BASE}/download/${encodeURIComponent(file.filename)}`
    : file.url;

  return (
    <div className="file-card">
      <div className="file-image-wrapper">
        {!imageLoaded && <div className="skeleton-loader"></div>}

        <img
          src={file.thumbnail}
          alt={file.filename}
          loading="lazy"
          decoding="async"
          className={imageLoaded ? "img-loaded" : "img-loading"}
          onLoad={() => setImageLoaded(true)}
          onError={(e) => {
            if (e.target.src !== file.url) {
              e.target.src = file.url;
            } else {
              e.target.style.display = "none";
            }
          }}
        />

        {onDelete && (
          <button
            className="action-circle-btn file-delete-btn"
            disabled={deleting}
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm("Delete this file?")) onDelete();
            }}
          >
            <img src="/assets/delete.png" alt="Delete" />
          </button>
        )}
      </div>

      <div className="file-meta">
        <span className="file-name" title={file.filename}>
          {file.filename}
        </span>

        <a
          href={downloadHref}
          download
          className="action-circle-btn download-btn"
        >
          <img src="/assets/download.png" alt="Download" />
        </a>
      </div>
    </div>
  );
}
